// extracted by mini-css-extract-plugin
module.exports = {"uploadMessage":"style_uploadMessage__QmO35","uploadBtn":"style_uploadBtn__7F2iH","remove":"style_remove__1r2xS","ol":"style_ol__C5pLT","error":"style_error__lt7OX"};